import { Heading, Text } from "@instacover/ui"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"

import { BaseLayout } from "../../components/layouts/BaseLayout"
import NotFoundIcon from "../../images/icons/NotFound.svg?react"
import { useCachedSessionLanguage } from "../../locales/useCachedSessionLanguage"
import { captureExceptionWithoutAlert } from "../../utils/monitoring/monitoring"

// An invalid link is not an app failure, so it is logged without alerting and kept out of the
// shared TRPCClientError group
const SENTRY_FINGERPRINT = ["instacar-session-not-found"]

type Props = {
  error?: unknown
}

export function NotFound(props: Props) {
  const { error } = props

  useCachedSessionLanguage()
  const { t } = useTranslation()

  useEffect(() => {
    if (error) {
      captureExceptionWithoutAlert(error, undefined, SENTRY_FINGERPRINT)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BaseLayout hideLocales dataTestId="not-found">
      <div className="h-vh-header flex flex-col items-center justify-between overflow-y-auto">
        <div className="text-ic-primary landscape-short:min-h-35 landscape-short:py-2 flex h-fit min-h-60 w-[90vw] max-w-[100vw] min-w-0 flex-1 items-center py-6">
          <NotFoundIcon className="h-full max-h-full w-full object-contain" />
        </div>

        <div className="w-full max-w-120 items-center px-8">
          <Heading as="h2" variant="h1">
            {t("error.notFound.heading")}
          </Heading>

          <div className="h-6 w-6 shrink-0" />

          <Text>{t("error.notFound.text")}</Text>

          <div className="h-11 w-11 shrink-0" />
        </div>
      </div>
    </BaseLayout>
  )
}
